import * as Types from '../../../types/graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateScheduledNotificationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  input?: Types.InputMaybe<Types.UpdateScheduledNotificationInput>;
}>;


export type UpdateScheduledNotificationMutation = { __typename?: 'Mutation', updateScheduledNotification: { __typename?: 'Notification', id: string, createdAt: string, updatedAt: string, en?: { __typename?: 'NotificationMessage', title?: string | null, body?: string | null } | null, de?: { __typename?: 'NotificationMessage', title?: string | null, body?: string | null } | null } };


export const UpdateScheduledNotificationDocument = gql`
    mutation UpdateScheduledNotification($id: ID!, $input: UpdateScheduledNotificationInput) {
  updateScheduledNotification(id: $id, input: $input) {
    id
    en {
      title
      body
    }
    de {
      title
      body
    }
    createdAt
    updatedAt
  }
}
    `;
export type UpdateScheduledNotificationMutationFn = Apollo.MutationFunction<UpdateScheduledNotificationMutation, UpdateScheduledNotificationMutationVariables>;

/**
 * __useUpdateScheduledNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledNotificationMutation, { data, loading, error }] = useUpdateScheduledNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduledNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledNotificationMutation, UpdateScheduledNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledNotificationMutation, UpdateScheduledNotificationMutationVariables>(UpdateScheduledNotificationDocument, options);
      }
export type UpdateScheduledNotificationMutationHookResult = ReturnType<typeof useUpdateScheduledNotificationMutation>;
export type UpdateScheduledNotificationMutationResult = Apollo.MutationResult<UpdateScheduledNotificationMutation>;
export type UpdateScheduledNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledNotificationMutation, UpdateScheduledNotificationMutationVariables>;